export const KM_HM_TEST_IDS = {
    PREFERENCES_WIZARD: "km-hm-preferences-wizard",
    PREFERENCES_WIZARD_BACK: "km-hm-preferences-wizard-back",
    PREFERENCES_WIZARD_EXIT: "km-hm-preferences-wizard-exit",
    PREFERENCES_WIZARD_EXIT_RETURN: "km-hm-preferences-wizard-exit-return",
    PREFERENCES_WIZARD_EXIT_SAVE: "km-hm-preferences-wizard-exit-save",
    PREFERENCES_WIZARD_PRIMARY: "km-hm-preferences-wizard-primary",
    PREFERENCES_WIZARD_ROOMS: "km-hm-preferences-wizard-rooms",
    PREFERENCES_WIZARD_SUMMARY_BUDGET: "km-hm-preferences-wizard-summary-budget",
    PREFERENCES_WIZARD_SUMMARY_LOCATION: "km-hm-preferences-wizard-summary-location",
    PREFERENCES_WIZARD_SUMMARY_SIZE: "km-hm-preferences-wizard-summary-size",
    PREFERENCES_WIZARD_SUMMARY_TOGGLE: "km-hm-preferences-wizard-summary-toggle",
    PREFERENCES_WIZARD_PROGRESS: "km-hm-preferences-wizard-progress",
    SENT_LEAD_MESSAGE: "km-hm-sent-lead-message",
    LIST_BANNER: "km-hm-list-banner",
    LIST_BANNER_CONSULTANT: "km-hm-list-banner-consultant",
    EMPTY_STATE_BANNER: "km-hm-empty-state-banner",
    EMPTY_STATE_TILE: "km-hm-home-match-empty-state-tile"
} as const;
export const KM_HM_TEST_IDS = {
    PREFERENCES_WIZARD: "km-hm-preferences-wizard",
    PREFERENCES_WIZARD_BACK: "km-hm-preferences-wizard-back",
    PREFERENCES_WIZARD_EXIT: "km-hm-preferences-wizard-exit",
    PREFERENCES_WIZARD_EXIT_RETURN: "km-hm-preferences-wizard-exit-return",
    PREFERENCES_WIZARD_EXIT_SAVE: "km-hm-preferences-wizard-exit-save",
    PREFERENCES_WIZARD_PRIMARY: "km-hm-preferences-wizard-primary",
    PREFERENCES_WIZARD_ROOMS: "km-hm-preferences-wizard-rooms",
    PREFERENCES_WIZARD_SUMMARY_BUDGET: "km-hm-preferences-wizard-summary-budget",
    PREFERENCES_WIZARD_SUMMARY_LOCATION: "km-hm-preferences-wizard-summary-location",
    PREFERENCES_WIZARD_SUMMARY_SIZE: "km-hm-preferences-wizard-summary-size",
    PREFERENCES_WIZARD_SUMMARY_TOGGLE: "km-hm-preferences-wizard-summary-toggle",
    PREFERENCES_WIZARD_PROGRESS: "km-hm-preferences-wizard-progress",
    SENT_LEAD_MESSAGE: "km-hm-sent-lead-message",
    LIST_BANNER: "km-hm-list-banner",
    LIST_BANNER_CONSULTANT: "km-hm-list-banner-consultant",
    EMPTY_STATE_BANNER: "km-hm-empty-state-banner",
    EMPTY_STATE_TILE: "km-hm-home-match-empty-state-tile"
} as const;
